import { brandConfig } from '../../../config/brands';
import { manualProductTabLabel } from '../../../config/brands/productLabels';
import { hardNavigate } from '../../../utils/navigation';
import styles from './AddProductChooserModal.module.css';

interface AddProductChooserModalProps {
  onClose: () => void;
  onSelectAsin: () => void;
  onSelectManual: () => void;
}

/**
 * 「+ 商品を追加」クリック後に出す追加方法の選択モーダル (計画書§4.1)。
 * ProductSelectorModal から Amazon連携を表示するブランドのみで起動される
 * (非表示ブランドはこのモーダルをスキップし、直接 ManualProductFormModal を開く)。
 */
export function AddProductChooserModal({ onClose, onSelectAsin, onSelectManual }: AddProductChooserModalProps) {
  const productShort = brandConfig.labels.productShort;
  // productsManualFirst のブランド (take8) はマニュアルを先頭に表示する
  const manualFirst = brandConfig.features.productsManualFirst === true;

  const manualOption = (
    <button key="manual" type="button" className={styles.optionButton} onClick={onSelectManual}>
      <span className={styles.optionLabel}>{manualProductTabLabel(brandConfig)}</span>
      <span className={styles.optionDesc}>{productShort}情報を手入力で1件登録します</span>
    </button>
  );
  const asinOption = (
    <button key="asin" type="button" className={styles.optionButton} onClick={onSelectAsin}>
      <span className={styles.optionLabel}>ASINから追加</span>
      <span className={styles.optionDesc}>Amazon商品ページのURLまたはASINから取得します</span>
    </button>
  );
  const apiOption = (
    <button
      key="api"
      type="button"
      className={styles.optionButton}
      onClick={() => hardNavigate('/products/amazon-listings')}
    >
      <span className={styles.optionLabel}>APIから追加</span>
      <span className={styles.optionDesc}>連携中のAmazonアカウントの出品商品から選びます</span>
    </button>
  );

  return (
    <div className="modal-overlay modal-overlay--nested" onClick={onClose}>
      <div className="modal-card modal-card--sm" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <span className="modal-title">{productShort}を追加</span>
          <button type="button" className="modal-close-button" aria-label="閉じる" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="modal-body">
          <div className={styles.optionList}>
            {manualFirst ? [manualOption, asinOption, apiOption] : [asinOption, apiOption, manualOption]}
          </div>
        </div>
      </div>
    </div>
  );
}
